/**
 * This is a function to look for a parameter in the url query string.
 *
 * @param {string} n - A string to search if is exists in the query string
 * @return {boolean} true if the param exists
 *
 * @example
 *
 *     urlCheck('mock')
 *     urlCheck('mobile')
 */

import queryString from 'query-string';
import has from 'lodash.has';

const parsedQS = queryString.parse(window.location.search);

const urlCheck = (param) => has(parsedQS, param);

export default urlCheck;
